import React from "react";
import { useQuoteById, useQuoteTypeNameByQuoteId } from "../Store/entities/quotes/hooks";
import Table from "../Parts/Table";
import PartsTable from "./PartsTable";
import { NewFabricSampleForm } from "./NewOptionFields/ShadeActions/NewFabricSampleForm";
import PSOutdoorTable from "./PSOutdoorTable";
import { UsePortalDispatch, UsePortalSelector } from "../Store";
import { selectAssemblyListByQuoteId } from "../Store/entities/assemblies/hooks";
import { useQuoteFabricSamplesByQuoteId } from "../Store/entities/fabricSamples/hooks";
import { useHWRItemsByQuoteId } from "../Store/entities/hardwareRequestItems/hooks";
import IndoorTable from "./IndoorTable";
import COROutdoorTable from "./COROutdoorTable";
import PSAwningsTableContainer from "./PSAwningsTableContainer";
import { deleteQuoteHwItem, updateQuoteHwItem } from "../Store/entities/hardwareRequestItems";
import { fakeRootType } from "../FakeRootType";
import AccessoryTable from "./AccessoryTable";
import { loadQuoteFabricSamples, updateQuoteFabricSample } from "../Store/entities/fabricSamples";

type InvoiceTableProps = {
	quoteId: number;
	ROOT: fakeRootType;
	unlockBySequenceId: (sequenceId: number) => void;
};

const InvoiceTable = ({ quoteId, unlockBySequenceId, ROOT }: InvoiceTableProps) => {
	const dispatch = UsePortalDispatch();

	const quote = useQuoteById(quoteId);

	const { editable } = quote ?? { editable: false };
	const productCategory = quote?.product_category ?? 'roller_shades';
	const showShadeTables = productCategory !== 'awnings';
	const showAwningTable = productCategory === 'awnings';

	const samples = useQuoteFabricSamplesByQuoteId(quoteId);
	const countAssemblyCount = UsePortalSelector(selectAssemblyListByQuoteId(quoteId));
	console.log(countAssemblyCount);

	const hwItems = useHWRItemsByQuoteId(quoteId);
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	return (
		<>
			{showShadeTables && (
				<>
					<IndoorTable
						quoteId={quoteId}
						unlockShadeBySequenceId={unlockBySequenceId}
						ROOT={ROOT}
					/>
					<COROutdoorTable
						quoteId={quoteId}
						unlockShadeBySequenceId={unlockBySequenceId}
						ROOT={ROOT}
					/>
					<PSOutdoorTable
						quoteId={quoteId}
						unlockShadeBySequenceId={unlockBySequenceId}
						ROOT={ROOT}
					/>
					<br />
				</>
			)}
			{showAwningTable && (
				<>
					<PSAwningsTableContainer
						quoteId={quoteId}
						ROOT={ROOT}
						unlockQuoteForEditing={() => unlockBySequenceId(0)}
					/>
					<br />
				</>
			)}
			<AccessoryTable
				quoteId={quoteId}
			/>
			<br />
			<div
				className="quote-table"
				style={{
					overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
				}}
			>
				<Table
					quoteType={quoteType}
					className="fabric-samples"
					noTBody
					style={{ width: '100%', zIndex: '20' }}
				>
					<NewFabricSampleForm
						key={
							`fabric-${(samples ?? []).reduce((sum, next) => sum + next.Quantity, 0)}`
						}
						quoteType={quoteType}
						quoteSamples={samples}
						onChange={(name: string, newQuantity: number) => {
							dispatch(updateQuoteFabricSample({
								quoteId,
								quantity: newQuantity,
								name
							})).then(() => {
								dispatch(loadQuoteFabricSamples(quoteId));
							});
						}}
						editable={editable}
					/>
				</Table>
			</div>
			<br />
			{hwItems.length > 0 && <div
				className="quote-table"
				style={{
					overflowX: 'auto', overflowY: 'hidden', marginBottom: '0.25em'
				}}
			>
				<Table
					noTBody
					style={{ width: '100%', zIndex: '19' }}
					className="PartsTable"
					quoteType={quoteType}
				>
					<PartsTable
						key="hw_request"
						hwRequestItems={hwItems}
						deleteItem={(lineItem: number) => {
							dispatch(deleteQuoteHwItem({
								quoteId,
								lineNumber: lineItem,
							}));
						}}
						update={(lineItem: number, quantity: number) => (
							dispatch(updateQuoteHwItem({
								quoteId,
								lineNumber: lineItem,
								quantity,
							})).unwrap()
						)}
						quoteType={quoteType}
						isEditable={editable}
						quoteId={quoteId}
					/>
				</Table>
			</div>}
		</>
	);
};

export default InvoiceTable;
